/* global femcare */

/**
 * Represents the product filter functionality.
 */
femcare.product.productFilter = {
    /**
     * Initializes the product filter.
     */
    init: function () {

        this.$filter = $('.product-filter');
        this.$filterOverlay = this.$filter.find('.product-filter__overlay');
        this.allRules = [];
        this.allCategoryCriteriaForQueryStrings = [];
        this.usedCategories = [];

        var url = new URL(window.location.href);
        var params = url.search;

        if (this.$filter.length) {

            this.initMembers();
            this.initCategoryObj();
            this.initAccordion();
            this.initOpenFilter();
            this.closeFilterOnAction();
            this.showFilteredItems();
            this.countAllProducts();
            if(!params.length) {
                this.countProductsByCriteria();
            }

            if (params.length){
                this.$productList.addClass('product-list--filtered');
                this.readQueryString(params);
                this.applyCriteria();
                this.showChips(this.allCategoryCriteriaForQueryStrings);
                this.animateChips(false);
                setTimeout(function(){
                    this.invokeFilter(this.allRules);
                    this.countProductsByCriteria();
                    this.sumSelectedProducts();
                }.bind(this),0);
            }

            this.initCheckboxFiltering();
            this.initClearAllChip();
            this.initClearSpecificChip();

        }
    },

    /**
     * Initializes the members of the product filter.
     */
    initMembers: function () {
        this.activeChipClass = 'active';
        this.activeChipSelector = '.product-filter__checkbox.active';
        this.orientation = $('body').hasClass('rtl') ? 'right' : 'left';
        this.clearChipMarginShift = 'margin-' + this.orientation;

        this.$filteredItemsOccurence = this.$filter.find('.product-filter__headline .occurence');
        this.filteredItemsDefaultVal = this.$filteredItemsOccurence.text();

        this.$clearOption = this.$filter.find('.product-filter__option--clear');
        this.$clearAllChip = this.$filter.find('.product-filter__chip--clear');
        this.$optionAfterClear = this.$clearOption.next();

        this.$filterChips = this.$filter.find('.product-filter__option');
        this.$chip = this.$filter.find('.product-filter__chip');
        this.$clearChip = this.$filter.find('.product-filter__chip--remove-filter');
        this.$filterCheckboxes = this.$filter.find('.product-filter__checkbox');
        this.$productList = $('.product-list');
        this.$productItems = this.$productList.find('.product-list__item');
        this.$totalItems = this.$filter.find('.product-filter__overlay-total-items span');
        this.$initFilter = this.$filter.find('.init-filter');
    },

    /**
     * Initializes the category object by extracting categories from HTML checkboxes.
     * Gets categoties from HTML checkboxes
     */
    initCategoryObj: function () {
        var usedCategories = [];
        this.$filterCheckboxes.each(function(index, element) {
            var category = $(element).data('category');
            usedCategories.push(category);
        }.bind(this));

        var uniqueCategory = usedCategories.filter(this.onlyUnique);
        this.usedCategories = uniqueCategory;
    },

    /**
     * Filters the checkboxes to only keep unique elements. Takes unique elements from array.
     * @param {*} value - The current value.
     * @param {number} index - The index of the current value.
     * @param {Array} self - The array being traversed.
     * @returns {boolean} - True if the value is unique, false otherwise.
     */
    onlyUnique: function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    },

    /**
     * Initializes the checkbox filtering functionality.
     */
    initCheckboxFiltering: function(){
        this.$filterCheckboxes.click(function(e){
            var $checkbox = $(e.target);
            this.checkIfSorted();
            $checkbox.toggleClass('active');
            this.applyCriteria();
            this.showChips(this.allCategoryCriteriaForQueryStrings);
            this.animateChips(false);
            this.addFilterToQueryString(this.allCategoryCriteriaForQueryStrings);
            this.invokeFilter(this.allRules);
            this.countProductsByCriteria();
            this.sumSelectedProducts();
        }.bind(this));
    },

    /**
     * Initializes the clear all chip functionality.
     */
    initClearAllChip: function(){
        this.$clearAllChip.click(function(e){
            this.checkIfSorted();
            this.$filterCheckboxes.removeClass(this.activeChipClass);
            this.animateChips(true);
            this.removeChips(e);
            this.removeQueryString(null, true);
            this.countSelectedFilters();
            this.applyCriteria();
            this.invokeFilter(null);
            this.countProductsByCriteria();
            this.sumSelectedProducts();
        }.bind(this));
    },

    /**
     * Initializes the clear specific chip functionality.
     */
    initClearSpecificChip: function(){
        this.$clearChip.click(function(e){
            this.checkIfSorted();
            var $clearChip = $(e.target);
            this.uncheckCheckbox($clearChip);
            this.removeChips(e);
            this.animateChips(false);
            this.countSelectedFilters();
            this.applyCriteria();
            this.invokeFilter(this.allRules);
            this.removeQueryString($clearChip, false);
            this.countProductsByCriteria();
            this.sumSelectedProducts();
        }.bind(this))
    },

    /**
     * Initializes the open filter functionality.
     */
    initOpenFilter: function() {
        this.$initFilter.click( function() {
            if (!this.$filterOverlay.hasClass('product-filter__overlay--visible')) {
                this.$filterOverlay.toggleClass('product-filter__overlay--visible');
                this.$filter.find('.product-filter--page-overlay').show();
            }
        }.bind(this));
    },

    /**
     * Initializes the close filter functionality.
     */
    initCloseFilter: function(){
        if(this.$filterOverlay.hasClass('product-filter__overlay--visible')){
            this.$filterOverlay.toggleClass('product-filter__overlay--visible');
            this.$filter.find('.product-filter--page-overlay').hide();
        }
    },

    /**
     * Closes the filter on user action.
     */
    closeFilterOnAction: function(){
        $('.product-filter--page-overlay').click(function(){
            this.initCloseFilter();
        }.bind(this));

        $('.product-filter__overlay-clear').click(function(e){
            this.$filterCheckboxes.removeClass(this.activeChipClass);
            this.animateChips(true);
            this.removeChips(e);
            this.removeQueryString(null, true);
            this.countSelectedFilters();
            this.applyCriteria();
            this.invokeFilter(null);
            this.initCloseFilter();
            this.countProductsByCriteria();
            this.sumSelectedProducts();
            //femcare.product.productSort.initSort();
        }.bind(this));
    },

    /**
     * Initializes the accordion functionality.
     */
    initAccordion: function () {
        var $accordion = $('.accordion--filters');
        if ($accordion.length) {
            femcare.general.accordion.init('.accordion--filters', 'content');
        }
    },

    /**
     * Calculates the sum of selected products for each category.
     */
    sumSelectedProducts: function () {
        var allSelectedOccurences = 0;
        this.$filter.find('.product-filter__category').each(function(index, element){
            var occurenceSum = 0;
            var occurence;
            $(element).find('.product-filter__checkbox.active').each(function(index, element){
                occurence = $(element).siblings('.occurence').text();
                occurenceSum += parseInt(occurence);
            })

            if(occurenceSum !== 0) {
                $(element).find('.accordion__header .selected-occurences').text(occurenceSum);
                allSelectedOccurences += occurenceSum;
            } else {
                $(element).find('.accordion__header .selected-occurences').text('');
            }
        })

        this.updateFilteredOccurence();
    },

    /**
     * Counts all the products and categorizes them by criteria.
     */
    countAllProducts: function () {
        var allProducts = [];
        this.$productItems.each(function (index, product) {
            var criteria = Object.keys($(product).data());
            Array.prototype.push.apply(allProducts, criteria)
        });

        var criteriaObj = {};
        this.usedCategories.forEach(function(key) {criteriaObj[key] = []});

        var splittedCriteria;
        allProducts.forEach(function (criteria, index) {
            if(criteria.includes('-')) {
                splittedCriteria = criteria.split('-');
                var category = splittedCriteria[0];
                var option = splittedCriteria[1].toLowerCase();
            } else {
                splittedCriteria = criteria.split(/(?=[A-Z])(.*)/);
                var category = splittedCriteria[0];
                var option = splittedCriteria[1];
            }

            if(category !== 'review') {
                var mixedOption = option.split(/(?=[A-Z])/).join('-').toLowerCase();
            }

            if(criteriaObj[category] !== undefined) {
                criteriaObj[category].push(mixedOption);
            }

        }.bind(this))

       this.allProductsCounted = criteriaObj;
    },

    /**
     * Counts the products based on the selected criteria.
     */
    countProductsByCriteria: function () {
        var allCriteria = [];
        var selectedOnlyOneCategory;
        var selectedCategory;
        this.$productList.find('.product-list__item:not([style*="display: none"])').each(function (index, product) {
            var criteria = Object.keys($(product).data());
            Array.prototype.push.apply(allCriteria, criteria)
        });

        var criteriaObj = {};
        this.usedCategories.forEach(function(key) {criteriaObj[key] = []});

        var splittedCriteria;
        this.checkSelectedCategory();
        allCriteria.forEach(function (criteria, index) {
            if(criteria.includes('-')) {
                splittedCriteria = criteria.split('-');
                var category = splittedCriteria[0];
                var option = splittedCriteria[1].toLowerCase();
            } else {
                splittedCriteria = criteria.split(/(?=[A-Z])(.*)/);
                var category = splittedCriteria[0];
                var option = splittedCriteria[1];
            }

            if(category !== 'review') {
                var mixedOption = option.split(/(?=[A-Z])/).join('-').toLowerCase();
            }
            selectedCategory = this.checkSelectedCategory();

            if (selectedCategory.length) {
                selectedOnlyOneCategory = true;
             } else {
               selectedOnlyOneCategory = false;
            }

            if(criteriaObj[category] !== undefined) {
                criteriaObj[category].push(mixedOption);
            }
        }.bind(this))

        this.addNumbersToFilters(criteriaObj, selectedOnlyOneCategory, selectedCategory);
    },

    /**
     * Checks the selected category based on active checkboxes.
     * @returns {string} - The selected category.
     */
    checkSelectedCategory: function () {
        var activeCategories = [];
        this.$filterCheckboxes.each(function(index, element){
            var activeCheckbox = $(element).hasClass('active');
            if(activeCheckbox) {
                activeCategories.push($(element).data('category'));
            }
        });

        var uniqueCategoryArr = activeCategories.filter(this.onlyUnique); 
        if(uniqueCategoryArr.length === 1) {
            return uniqueCategoryArr[0];
        } else {
            return '';
        }
    },

    /**
     * Adds numbers to the filters based on the selected criteria.
     * @param {object} obj - The criteria object.
     * @param {boolean} selectedOnlyOne - Indicates if only one category is selected.
     * @param {string} selectedCategory - The selected category.
     */
    addNumbersToFilters: function (obj, selectedOnlyOne, selectedCategory) {
        if (selectedOnlyOne) {
            this.$filterCheckboxes.each( function(index, element){
                var category = $(element).data('category');
                var option = $(element).data('option').toString();

                if (category === selectedCategory) {
                    var occurences = this.allProductsCounted[category].filter(function(x){ return x===option}).length;
                    $(element).siblings('.occurence').text(occurences);
                } else {
                    var occurences = obj[category].filter(function(x){ return x===option}).length;
                    $(element).siblings('.occurence').text(occurences);
                }
            }.bind(this))
        } else {
            this.$filterCheckboxes.each( function(index, element){
                var category = $(element).data('category');
                var option = $(element).data('option').toString();

                var occurences = obj[category].filter(function(x){ return x===option}).length;
                $(element).siblings('.occurence').text(occurences);
            })
        }
    },

    /**
     * Applies the selected criteria and formulates the filtering rules.
     */
    applyCriteria: function () {
        var criteriaObj = {};
        this.usedCategories.forEach(function(key) {criteriaObj[key] = []});

        this.$filterCheckboxes.filter(this.activeChipSelector).each(function (index, chip) {
            var category = $(chip).data('category');
            var option = $(chip).data('option');

            criteriaObj[category].push({ category: category, option: option });
        });
        var allCategoryCriteria = [];

        var allCriteriaNames = Object.keys(criteriaObj);
        allCriteriaNames.forEach(function(key, index) {
            if(criteriaObj[key].length) {
                allCategoryCriteria.push(criteriaObj[key]);
            }
        });

        this.allRules = [];
        this.formulateRules(allCategoryCriteria, 0, this.allRules, []);
        this.allCategoryCriteriaForQueryStrings = allCategoryCriteria.flat(1);
    },

    /**
     * Formulates the filtering rules based on the selected criteria.
     * @param {Array} allCategoryCriteria - The category criteria.
     * @param {number} categoryIndex - The index of the current category.
     * @param {Array} allRules - The array of all rules.
     * @param {Array} rule - The current rule being formulated.
     */
    formulateRules: function(allCategoryCriteria, categoryIndex, allRules, rule) {
        // If the criteria selected is x1, x2, y1 and they belong to x and y categories respectively
        // then the matching items must satisfy ( x1 AND y1 ) OR ( x2 AND y1 ).
        // This is can be represented as a cartesian product where the categories are the sets.

        if(allCategoryCriteria.length !== 0){
            for (var optionIndex = 0; optionIndex < allCategoryCriteria[categoryIndex].length; optionIndex++) {
                var selectedOption = allCategoryCriteria[categoryIndex][optionIndex];
                if (categoryIndex + 1 < allCategoryCriteria.length) {
                    this.formulateRules(allCategoryCriteria, categoryIndex + 1, allRules, rule.concat([selectedOption]));
                } else {
                    this.allRules.push(rule.concat([selectedOption]));
                }
            }
        }
    },

    /**
     * Invokes the filter with the specified rules.
     * @param {Array} rules - The filtering rules.
     */
    invokeFilter: function (rules) {
        this.$filter.trigger('filter', { rules: rules });
        this.activateButtons();
        this.$productList.addClass('product-list--filtered');
        this.$productList.find('.product-list__item:not([style*="display: none"])').addClass('product-list__item--filtered');
    },

    /**
     * Activates or deactivates buttons based on the presence of filtering rules.
     */
    activateButtons: function () {
        if(this.allRules.length !== 0) {
            this.$initFilter.addClass('active');
        } else {
            this.$initFilter.removeClass('active');
        }
    },

    /**
     * Shows the filter chips based on the selected criteria.
     * @param {Array} rules - The selected criteria.
     */
    showChips: function (rules) {
        this.$filterChips.removeClass('show');
        rules.forEach(function(element, index){
            var category = element.category;
            var option = element.option;

            this.$chip.filter('[data-category="' + category + '"][data-option="'+ option +'"]').parent('.product-filter__option').addClass('show');
        }.bind(this));
        this.$filter.find('.product-filter__heading-container').addClass('product-filter__heading-container--translated');
        this.countSelectedFilters();
    },

    /**
     * Removes the filter chips based on user action.
     * @param {Event} event - The event object.
     */
    removeChips: function (event) {
        event.preventDefault();
        var $chip = $(event.target);
        var clearAllFilters = false;
        var visiblieChips = this.$filterChips.filter('.show');

        if( $chip.hasClass('product-filter__overlay-clear') || $chip.hasClass('product-filter__chip--clear')){
            var clearAllFilters = true;
        }

        if (clearAllFilters || visiblieChips.length === 2) {
            visiblieChips.removeClass('show');
        } else {
            var $selectedChip = $chip.parents('.product-filter__option');
            $selectedChip.removeClass('show');
        }

        this.$filter.find('.product-filter__heading-container').removeClass('product-filter__heading-container--translated');
    },

    /**
     * Animates the filter chips based on user action.
     * @param {boolean} isClearAll - Indicates if all filters are being cleared.
     */
    animateChips: function(isClearAll){
        var marginShiftOptions = {};
        var clearOptionWidth = this.$clearOption.outerWidth();
        var firstVisibleChip = this.$clearOption.siblings('.show').first();
        this.$filterChips.css({'margin-left': '0px', 'margin-right': '0px'});

        if(isClearAll){
            this.$filterCheckboxes.removeClass(this.activeChipClass);
            marginShiftOptions[this.clearChipMarginShift] = 0;
            this.$clearAllChip.animate(
                { opacity: 0 },
                300,
                function () {
                    this.$clearOption.css('visibility', 'hidden');
                }.bind(this)
            );
        } else {
            marginShiftOptions[this.clearChipMarginShift] = clearOptionWidth + 10;
            firstVisibleChip.animate(
                marginShiftOptions,
                300,
                function () {
                    this.$clearOption.addClass('show').css('visibility', 'visible');
                    this.$clearOption.find('.product-filter__chip').animate({ opacity: 1 }, 300);
                }.bind(this)
            );
        }
    },

    /**
     * Adds the selected filter criteria to the query string.
     * @param {Array} rules - The selected criteria.
     */
    addFilterToQueryString: function (rules) {
        var url = new URL(window.location.href);
        var clearUrl = url.href.split('?')[0];
        window.history.replaceState(null, '', clearUrl);
        var params = new URLSearchParams(clearUrl.search);

        rules.forEach(function(element, index) {
            var criteria = element.category + '-' + element.option;
            params.append('f', criteria);
            window.history.replaceState({}, '', '?' + params);
        })
    },

    /**
     * Reads the query string and selects the corresponding filter checkboxes.
     * @param {string} params - The query string parameters.
     */
    readQueryString: function(params){
        var queryParams = (params.substring(1)).split('&');
        var criteriaPairs = [];

        queryParams.forEach(function(element, index){
            criteriaPairs.push(element.split('=')[1])
        })

        criteriaPairs.forEach(function(element, index){
            var category = element.split(/-(.*)/s)[0];
            var option = element.split(/-(.*)/s)[1];

            this.$filterCheckboxes.filter('[data-option="'+ option + '"]').addClass(this.activeChipClass);
        }.bind(this));
    },

    /**
     * Removes the filter criteria from the query string.
     * @param {jQuery} $chipClose - The close button of the chip being removed.
     * @param {boolean} isClearAll - Indicates if all filters are being cleared.
     */
    removeQueryString: function($chipClose, isClearAll) {
        var url = new URL(window.location.href);
        var params = url.search;

        if(isClearAll){
            var clearUrl = url.href.split('?')[0];
            window.history.replaceState(null, '', clearUrl);
        } else {
            var $chipFilter = $chipClose.parents('.product-filter__chip');

            var category = $chipFilter.data('category');
            var option = $chipFilter.data('option');
            var criteria = 'f=' + category + '-' + option;

            var updatedParams = params.replace(criteria, '');

            if(updatedParams.includes('&&')){
                updatedParams = updatedParams.replace('&&', '&');
            } else if (updatedParams.includes('?&')){
                updatedParams = updatedParams.replace('?&', '?');
            }

            if(updatedParams.endsWith('&')){
                updatedParams = updatedParams.slice(0, -1);
            }

            window.history.replaceState({}, '', updatedParams);
        }
    },

    /**
     * Unchecks the checkbox associated with the specified chip.
     * @param {jQuery} $chipClose - The close button of the chip.
     */
    uncheckCheckbox: function($chipClose){
        var $chipFilter = $chipClose.parents('.product-filter__chip');
        var category = $chipFilter.data('category');
        var option = $chipFilter.data('option');

        this.$filterCheckboxes.filter('[data-category' + category +'],[data-option="'+ option + '"]').removeClass('active');
    },

    /**
     * Counts the number of selected filters and updates the display.
     */
    countSelectedFilters: function () {
        var noOfSelectedFilters = this.$filter.find('.product-filter__checkbox.active').length;

        if(noOfSelectedFilters !== 0) {
            this.$filter.find('.init-filter .occurence').text('(' + noOfSelectedFilters + ')');
            this.$filter.find('.init-filter .icon-filter').hide();
        } else {
            this.$filter.find('.init-filter .occurence').text('');
            this.$filter.find('.init-filter .icon-filter').show();
        }
    },

    /**
     * Shows the filtered items based on user action.
     */
    showFilteredItems: function() {
        this.$filterOverlay.find('.product-filter__overlay--show-items').click(function(){
            this.showChips(this.allCategoryCriteriaForQueryStrings);
            this.animateChips(false);
            this.initCloseFilter();
        }.bind(this));

    },

    /**
     * Updates the filtered items occurrence count.
     */
    updateFilteredOccurence: function(){
        var noOfFilteredItems = this.$productList.find('.product-list__item:not([style*="display: none"])').length;

        if(this.allRules.length === 0 ){
            //In this case text would be default value (All)
            this.$filteredItemsOccurence.text(this.filteredItemsDefaultVal);
            this.$totalItems.text('0');
        } else {
            this.$filteredItemsOccurence.text(noOfFilteredItems);
            this.$totalItems.text(noOfFilteredItems);
        }
    },

    /**
     * Checks if the product list is sorted and destroys the sorting if necessary.
     */
    checkIfSorted: function(){
        if ($('.product-list__container').hasClass('shuffle')) {
                femcare.product.productSort.destroySorting();
        }
    }
};
